import { createSlice } from "@reduxjs/toolkit";
import { getRouteName, ROUTE_MAP } from "../../utils/Routes";

const getPagesToRemove = (newUrl) => {
  return ROUTE_MAP
    .filter(route => route.removeOn?.includes(newUrl))
    .map(route => route.url);
};

const historySlice = createSlice({
  name: "history",
  initialState: {
    pageHistory: JSON.parse(localStorage.getItem("pageHistory")) || [],
  },
  reducers: {
    addPage: (state, action) => {
      const { pathname, state: navState } = action.payload;
      
      if (pathname !== '/' && pathname !== '/putaway/posted-reverse-pick-putaway') {
        const pageName = getRouteName(pathname);
        const newEntry = { 
          url: pathname, 
          name: pageName,
          state: navState
        };

        // Get pages that should be removed when this page is added
        const pagesToRemove = getPagesToRemove(pathname);
        
        // Filter out pages that should be removed
        let updatedHistory = state.pageHistory.filter(
          page => !pagesToRemove.includes(page.url)
        );

        // Check if this exact page already exists
        const exists = updatedHistory.some(
          page => page.url === pathname && 
                 JSON.stringify(page.state) === JSON.stringify(navState)
        );

        if (!exists) {
          updatedHistory = [...updatedHistory, newEntry].slice(-8);
          state.pageHistory = updatedHistory;
          localStorage.setItem("pageHistory", JSON.stringify(updatedHistory));
        }
      }
    },
    removePage: (state, action) => {
      const { url, state: pageState } = action.payload;
      state.pageHistory = state.pageHistory.filter(
        page => !(page.url === url && 
                 JSON.stringify(page.state) === JSON.stringify(pageState))
      );
      localStorage.setItem("pageHistory", JSON.stringify(state.pageHistory));
    },
  },
});

export const { addPage, removePage } = historySlice.actions;
export default historySlice.reducer;